import { Component } from 'vue';

class TableComponentLoader {
	public loadOrganisationUsersTable(): Promise<Component> {
		return import('@/presentation/components/organisation-users-table/organisation-users-table.vue');
	}

	public loadActAccessTable(): Promise<Component> {
		return import('@/presentation/components/act-access-table/act-access-table.vue');
	}
}

export default new TableComponentLoader();
